"use client";
import { fileMatchesAccept as e } from "../../../utils/utils.mjs";
import { useFileInput as t } from "../../atoms/FileInput/useFileInput.mjs";
import { useEffect as n, useMemo as r, useState as i } from "react";
//#region src/components/molecules/ImageFileInput/useImageFileInput.tsx
var a = "image/";
function o(t, n) {
	return n.length > 0 && !e(t, n) ? !1 : t.type.startsWith(a);
}
var s = (e, a = {}) => {
	let s = r(() => a.accept ?? [], [a.accept]), c = a.accept?.length ?? 0, l = t(e, {
		...a,
		accept: s
	}), [u, d] = i(null);
	return n(() => {
		let { file: e } = l;
		if (!e) {
			d(null);
			return;
		}
		let t = (Array.isArray(e) ? e : [e]).filter((e) => o(e, s));
		if (t.length === 0) {
			d(null);
			return;
		}
		let n = t.map((e) => URL.createObjectURL(e));
		return d(n), () => {
			n.forEach((e) => URL.revokeObjectURL(e));
		};
	}, [l.file, c]), {
		...l,
		previewUrls: u
	};
};
//#endregion
export { s as useImageFileInput };
